import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { GlobalStyles } from "./styles/GlobalStyles";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { iniciarRegistro } from "./registro/registro";

// Producción normal (raíz del dominio) usa BrowserRouter (URLs limpias).
// La build de prueba en un subpath (ej. /v2.1) se compila con
// REACT_APP_HASH_ROUTER=1 y usa HashRouter, así las rutas cuelgan del "#" y no
// hace falta tocar la config de Apache para el fallback del SPA.
const Router = process.env.REACT_APP_HASH_ROUTER ? HashRouter : BrowserRouter;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <GlobalStyles />
        <Router>
          <App />
        </Router>
      </PersistGate>
    </Provider>
  </>
);

// Registro de actividad en el backend (no bloquea nada de la web).
iniciarRegistro();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
